const blockContainingElements = new Set([
    "DL",
    "FIELDSET",
    "FIGURE",
    "HEAD",
    "OL",
    "TABLE",
    "TBODY",
    "TFOOT",
    "THEAD",
    "TR",
    "UL",
]);

export const isBlockContainingElement = (node) => blockContainingElements.has(node.nodeName);

const blockElements = new Set([
    "ADDRESS",
    "ARTICLE",
    "ASIDE",
    "BLOCKQUOTE",
    "BODY",
    "CANVAS",
    "DD",
    "DIV",
    "DL",
    "DT",
    "FIELDSET",
    "FIGCAPTION",
    "FIGURE",
    "FOOTER",
    "FORM",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "HEADER",
    "HGROUP",
    "HR",
    "LI",
    "MAIN",
    "NAV",
    "NOSCRIPT",
    "OL",
    "P",
    "PRE",
    "SECTION",
    "TABLE",
    "TBODY",
    "TD",
    "TFOOT",
    "TH",
    "THEAD",
    "TR",
    "UL",
    "VIDEO",
]);

export const isBlockElement = (node) => blockElements.has(node.nodeName);

const inlineElements = new Set([
    "A",
    "ABBR",
    "ACRONYM",
    "B",
    "BIG",
    "CITE",
    "DEL",
    "EM",
    "I",
    "INS",
    "SMALL",
    "SPAN",
    "STRONG",
    "SUB",
    "SUP",
    "TEXTAREA",
    "TIME",
    "TT",
]);

export const isInlineElement = (node) => inlineElements.has(node.nodeName);

const keepEmptyBlockElements = new Set(["TD", "TH", "CANVAS", "DT", "DD", "HR"]);

export const shouldRemoveEmptyBlockElement = (node) =>
    !keepEmptyBlockElements.has(node.nodeName) && !node.hasChildNodes();

export const isTextNode = (node) => node.nodeType === Node.TEXT_NODE;
export const isElementNode = (node) => node.nodeType === Node.ELEMENT_NODE;
